module.exports = __webpack_public_path__ + "static/media/leaf.f57fe5b6.png";